import { useTranslation } from 'next-i18next'

import { NewsType } from '~/types/media'

export default function useMediaNewsNav(): Array<{ label: string; key: NewsType }> {
  const { t } = useTranslation('media')

  return [
    {
      label: t('newsNavLatestNews'),
      key: NewsType.ALL,
    },
    {
      label: t('newsNavArticles'),
      key: NewsType.ARTICLE,
    },
    {
      label: t('newsNavAudios'),
      key: NewsType.AUDIO,
    },
    {
      label: t('newsNavVideos'),
      key: NewsType.VIDEO,
    },
  ]
}
